import React from 'react'
import Layout from '../../Components/Layout'

export default function PermissionError() {
  return (
    <Layout>
      <div className="breadcrumb-bar breadcrumb-bg-04 text-center">
    <div className="container">
        <div className="row">
            <div className="col-md-12 col-12">
                <h2 className="breadcrumb-title mb-2">Error</h2>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center mb-0">
                        <li className="breadcrumb-item">
                            <i className="isax isax-home5"></i>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Error
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div>
        <div className="d-flex flex-row" style={{ margin:'100px' }}>
          <p style={{ fontSize:'60px', margin:'auto' }}>403 Forbidden</p>
        </div>
    </Layout>
  )
}
